<div class="menu-container" [@slideEnterLeaveLeft] appDarkMode>
  <div class="menu-app-icon" [routerLink]="['/']">
    <img [src]="appLogoSrc" [alt]="appName">
  </div>
  <div class="menu-items-container">
    <ng-container *ngFor="let item of menuItems">
      <div class="menu-item"
           *ngIf="item.conditionallyShown == null || item.conditionallyShown != null && item.conditionallyShown"
           [pxTooltip]="item.title ?? ''"
           pxTooltipPlacement="right"
           [ngClass]="active === item.routerLink ? 'active' : ''"
           [routerLink]="['/' + item.routerLink]">
        <svg-icon class="menu-icon-svg" [attr.data-icon]="item.icon" [src]="'assets/icons/' + item.icon" [ngClass]="item.class ? item.class : ''"></svg-icon>
      </div>
    </ng-container>
  </div>
  <div class="menu-user-container">
    <ng-container *ngIf="extraHelpTemplate; else helpTemplate">
      <ng-container *ngTemplateOutlet="extraHelpTemplate"></ng-container>
    </ng-container>
    <ng-template #helpTemplate>
      <app-centrui-help-form></app-centrui-help-form>
    </ng-template>
<!--    <ng-container *ngIf="authService.userObject.type === 'super'">-->
<!--      -->
<!--    </ng-container>-->
    <div class="menu-user-avatar-container"
         pxTooltip="Profile"
         pxTooltipPlacement="right"
         [ngClass]="active === 'profile' ? 'active' : ''" [routerLink]="['/profile']">
      <div class="border-left animate__animated animate__fadeIn animate__faster"></div>
      <app-centrui-avatar *ngIf="authService.userObject" [src]="authService.userObject.file ?? '/assets/img/avatar.svg'" [avatarType]="avatarType" [fullName]="fullName" [firstInitial]="firstInitial"></app-centrui-avatar>
    </div>
    <div class="powered-by" (contextmenu)="onPoweredByContextMenu($event)">
      <a href="https://nine-labs.com" target="_blank">
        <img src="https://www.polarix.io/assets/images/9labs.svg" style="width:40%; height: auto">
      </a>
    </div>
  </div>
</div>
